import React, {useEffect, useState} from "react"
import {Outlet, useLocation, useNavigate, useOutletContext} from "react-router-dom";
import api, {requestFailed} from "../Scripts/api";
import ExploreBar from "../Components/ExploreBar";
import PostCard from "../Components/PostCard";
import Loading from "../Components/Loading";

function Explore() {

    const navigate = useNavigate()
    const oc = useOutletContext().oc
    const locarr = useLocation().pathname.split('/').filter((char) => char !== '')
    const location = locarr[locarr.length - 1]
    const [posts, setPosts] = useState()
    const [tags, setTags] = useState([])

    const getExplore = (tagsToUse) => {
        api.get(`/api/getexplore`, {
            params: {account: oc.account, tags: tagsToUse}
        }).then((response) => {
            if (response.data) setPosts(response.data)
        }).catch(requestFailed)
    }

    const addTag = (tag) => {
        if (!tags.includes(tag)) {
            const nextTags = [...tags, tag]
            setTags(nextTags)
            navigate("/explore/tags=" + nextTags.join('&'))
        }
    }

    const removeTag = (tag) => {
        if (tags.includes(tag)) {
            const nextTags = tags.filter((item) => item !== tag)
            setTags(nextTags)
            if (nextTags[0]) navigate("/explore/tags=" + nextTags.join('&'))
            else navigate("/explore")
        }
    }

    useEffect(() => {
        if (locarr[locarr.length - 2]?.startsWith("post")) navigate("/post/" + location)
    }, [])


    useEffect(() => {
        let nextTags = []
        if (location?.startsWith("tags=")) {
            nextTags = location.substring(location.indexOf('=') + 1).split('&')
            setTags(nextTags)
        }
        else if (location?.startsWith("explore")) setTags([])
        getExplore(nextTags)
    }, [location])

    return (
        <div id="explore">
            <ExploreBar account={oc.account} tags={tags} addTag={(tag) => addTag(tag)} removeTag={(tag) => removeTag(tag)}/>
            <p id="resultcount">{posts ? (posts.length == 1 ? posts.length + " result" : posts.length + " results") : ''}</p>
            <div id="postgrid">
                {!posts && <Loading/>}
                {posts && posts.map(({title, text, tags, url, likes}) => (
                    <PostCard key={url} title={title} text={text} tags={tags} url={"post/" + url} addTag={(tag) => addTag(tag)}/>
                ))}
            </div>
            <Outlet context={{oc: oc}}/>
        </div>
    )
}

export default Explore;
